import { useState } from 'react';
import ClientSearch from '../components/ClientSearch';
import OrderDetails from '../components/OrderDetails';
import OrderDetailsSkeleton from '../components/OrderDetailsSkeleton';
import { Order, OrderItem, VoucherInfo } from '../types';
import { searchOrders, getOrderDetails } from '../services/api';
import { PageTitle } from "../../../../_metronic/layout/core";

type Screen = 'search' | 'details' | 'detailsLoading';

export default function Infrapay() {
  const [currentScreen, setCurrentScreen] = useState<Screen>('search');
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [selectedOrderItems, setSelectedOrderItems] = useState<OrderItem[]>([]);
  const [selectedOrderVouchers, setSelectedOrderVouchers] = useState<VoucherInfo[]>([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [orders, setOrders] = useState<Order[]>([]);

  const handleSearch = async (searchTerm: string) => {
    setIsSearchLoading(true);
    setHasSearched(true);

    try {
      const data = await searchOrders(searchTerm);
      setOrders(data);
    } catch (error) {
      console.error('Search failed:', error);
      setOrders([]);
    } finally {
      setIsSearchLoading(false);
    }
  };

  const handleOrderSelect = async (order: Order) => {
    setCurrentScreen('detailsLoading');

    try {
      const orderDetails = await getOrderDetails(order.orderNumber);
      setSelectedOrder(orderDetails.order);
      setSelectedOrderItems(orderDetails.items);
      setSelectedOrderVouchers(orderDetails.vouchers || []);
      setCurrentScreen('details');
    } catch (error) {
      console.error('Failed to fetch order details:', error);
      setCurrentScreen('search');
    }
  };

  const handleBackToSearch = () => {
    setSelectedOrder(null);
    setSelectedOrderItems([]);
    setSelectedOrderVouchers([]);
    setCurrentScreen('search');
  };

  return (
    <>
      <PageTitle>Infrapay</PageTitle>
      {currentScreen === 'search' && (
        <ClientSearch
          orders={orders}
          isLoading={isSearchLoading}
          hasSearched={hasSearched}
          onSearch={handleSearch}
          onOrderSelect={handleOrderSelect}
        />
      )}

      {currentScreen === 'detailsLoading' && (
        <OrderDetailsSkeleton />
      )}

      {currentScreen === 'details' && selectedOrder && (
        <OrderDetails
          order={selectedOrder}
          orderItems={selectedOrderItems}
          vouchers={selectedOrderVouchers}
          onBack={handleBackToSearch}
        />
      )}
    </>
  );
}
